// extracted by mini-css-extract-plugin
module.exports = {"menu":"e_0y","alignRight":"e_1y","alignLeft":"e_2y","item":"e_3y","icon":"e_4y","soft":"e_5y"};